<template>
  <Splitpanes class="default-theme">
    <Pane size="25" min-size="20" max-size="40">
      <createconversation
        class="mt-3"
        :acls="ACLS"
        :recordsIamAuthorizedOn="recordsIamAuthorizedOn"
        :currentlySelectedAccount="currentlySelectedAccountSetter"
        @refreshconversations="refreshMessages"
      />
      <v-list dense nav two-line>
        <v-subheader class="text-body-1 flex-column align-start">
          <div>Channels</div>
          <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
        </v-subheader>
        <div v-if="!loading && !allConversations">
          <h3>Nothing here yet.</h3>
          Create a channel to get started
        </div>
        <v-list-item-group v-model="selectedConversation" color="primary">
          <v-list-item
            v-for="conv of allConversations"
            :key="conv._id"
            :value="conv"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ conv.conversation_name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ recipientList(conv) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="conv.msgs && !isUnreadMessages(conv)">
                Last message was {{ lastMsgDateTime(conv) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="isUnreadMessages(conv)">
                UNREAD MESSAGES!
              </v-list-item-subtitle>
              <v-list-item-subtitle v-else>
                No messages
              </v-list-item-subtitle>
            </v-list-item-content>
            <channelmenu
              :acls="ACLS"
              :recordsIamAuthorizedOn="recordsIamAuthorizedOn"
              :currentlySelectedAccount="currentlySelectedAccountSetter"
              @refreshconversations="refreshMessages"
              :channel="conv"
            />
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </Pane>
    <Pane size="75" class="d-flex flex-column">
      <accountselect
        class="flex-grow-0 flex-shrink-0"
        :norecordselected="noRecordSelected"
        :recordsIamAuthorizedOn="recordsIamAuthorizedOn"
        @newaccountselected="handleNewAccountSelected($event)"
      />
      <div
        v-if="selectedConversation && typeof selectedConversation === 'object'"
        class="d-flex mx-5 mb-2 flex-grow-0 flex-shrink-0"
      >
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="refreshMessages()">
          <v-icon class="mr-1">mdi-refresh</v-icon>
          Refresh
        </v-btn>
      </div>
      <messageViewer
        v-if="selectedConversation && typeof selectedConversation === 'object'"
        :currentConversationProto="currentConversationProto"
        :messages="selectedConversation.msgs"
        @opendeletemessagemodal="handleDeleteMessage($event)"
      />
      <div
        v-show="
          selectedConversation && typeof selectedConversation === 'object'
        "
        class="flex-grow-0 flex-shrink-0"
      >
        <messagetextentry
          v-show="
            selectedConversation && typeof selectedConversation === 'object'
          "
          @sendmessage="sendmessage($event)"
        />
      </div>
      <div
        v-if="!selectedConversation && typeof selectedConversation === 'object'"
        class="text-h6 font-weight-regular ma-2 text-center"
      >
        Please select a channel to see messages
      </div>
      <!-- </div> -->
      <deletemessagemodal
        @closeDeleteMessageModal="closeDeleteMessageModal"
        :showDeleteMessageModal="showDeleteMessageModal"
        :currentlySelectedAccount="currentlySelectedAccountSetter"
        :messageForDeletion="messageForDeletion"
        @refreshconversations="refreshMessages"
      />
    </Pane>
  </Splitpanes>
</template>

<script>
import { Splitpanes, Pane } from "splitpanes";

import { mapGetters, mapState } from "vuex";
import channelmenu from "./components/ChannelMenu.vue";
import createconversation from "./components/createConversation.vue";
import messageViewer from "./components/messageViewer.vue";
import messagetextentry from "./components/MessageTextEntry.vue";
import accountselect from "./components/accountSelect.vue";
// import contacts from "./components/contacts.vue";
// import richtexteditor from "../../../utils/components/rich-text-editor-tiptap.vue";
import "splitpanes/dist/splitpanes.css";
import deletemessagemodal from "./components/DeleteMessageModal.vue";

import moment from "moment";

export default {
  components: {
    Splitpanes,
    Pane,
    createconversation,
    channelmenu,
    messageViewer,
    accountselect,
    // contacts,
    messagetextentry,
    // richtexteditor,
    deletemessagemodal
  },
  data() {
    return {
      input: "",
      search: "",
      userData: {},
      auth_users: [],
      allConversations: [],
      selectedConversation: false,
      currentConversationProto: {},
      currentMessageProto: {},
      conversationsmessages: [],
      noRecordSelected: true,
      loading: false,
      locallySetAccount: false,
      showDeleteMessageModal: false,
      messageForDeletion: {}
    };
  },
  watch: {
    currentlySelectedAccount: function(newVal) {
      this.noRecordSelected = !newVal;
      if (newVal) {
        this.getAcls(newVal);
        this.fetchMessages(newVal);
      } else {
        this.auth_users.splice(0);
        this.allConversations.splice(0);
        this.selectedConversation = false;
      }
    },
    selectedConversation: async function(conv) {
      if (conv && typeof conv === "object") {
        let messageproto = await this.$store.dispatch("getMessageProto", conv);
        this.currentMessageProto = messageproto;
      }
    },
    allConversations: function() {
      if (Object.keys(this.allConversations).length) {
        for (let conv of this.allConversations) {
          if (conv._id == this.selectedConversation._id) {
            this.selectedConversation = conv;
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      loginDetails: "getUser",
      currentlySelectedAccount: "getCurrentlySelectedAccount"
    }),
    ...mapState({
      currentlySelectedRecord: state => state.records.currentlySelectedRecord,
      ACLS: state => state.app.myacls,
      recordsIamAuthorizedOn: state => state.app.recordsiamauthorizedon
    }),
    currentlySelectedAccountSetter: function() {
      if (this.locallySetAccount) {
        return this.locallySetAccount;
      } else {
        return this.currentlySelectedAccount;
      }
    }
  },
  async created() {
    if (this.loginDetails) {
      this.userData = await JSON.parse(sessionStorage.getItem("userData"));
    }
  },
  mounted() {
    // wait 5 seconds for message to be sent and fetch messages
    setInterval(async () => {
      if (this.locallySetAccount) {
        await this.fetchMessages(this.locallySetAccount);
      }
    }, 120000);
  },
  methods: {
    saveInput($event) {
      this.input = $event;
    },
    async getAcls(username) {
      let acls = await this.$store.dispatch("getAcls", username);
      this.auth_users = acls.auth_users;
    },
    async getMyAcls(username) {
      let acls = await this.$store.dispatch("getMyAcls", username);
      this.auth_users = acls.auth_users;
    },
    async fetchMessages(username) {
      this.loading = true;
      let conversation = await this.$store.dispatch("getMessages", username);
      this.allConversations = conversation;
      this.loading = false;
    },

    setConversationMessages() {},
    sendmessage($event) {
      let messageObj = { message: this.currentMessageProto.proto };
      messageObj.message.content = $event;
      this.$store.dispatch("sendMessage", messageObj);
      setTimeout(() => {
        this.refreshMessages();
      }, 3500);
    },
    runRefreshMessages() {
      setTimeout(() => {
        this.refreshMessages();
      }, 1000);
    },
    async refreshMessages() {
      await this.fetchMessages(this.currentlySelectedAccountSetter);
    },
    lastMsgDateTime(conv) {
      const last = conv.msgs.at(-1);

      return moment(last.timestamp).fromNow();
    },
    handleNewAccountSelected($event) {
      this.locallySetAccount = $event;

      if ($event) {
        this.getAcls($event);
        this.fetchMessages($event);
      }
    },
    handleDeleteMessage($event) {
      this.showDeleteMessageModal = true;
      this.messageForDeletion = $event;
    },
    closeDeleteMessageModal() {
      this.showDeleteMessageModal = false;
      this.messageForDeletion = {};
    },
    recipientList(conv) {
      const res = conv.recipients.map(user => user.username);
      return res.join(", ");
    },
    isUnreadMessages(conv) {
      if (!conv.msgs) return false;
      for (let msg of conv.msgs) {
        if (
          msg.recip_states[this.loginDetails.username]?.state === "NOT_READ"
        ) {
          return true;
        }
      }

      return false;
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      }
    }
  }
};
</script>

<style lang="scss">
.splitpanes.default-theme {
  .splitpanes__pane {
    background-color: #fff;
  }
}

#Pane {
  height: 100vh;
}
#message-and-text-entry-pane {
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  height: 100%;
}
#text-box {
  // height: 20vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  // margin-bottom: 21vh;
  padding: 2px;
}
#text-entry {
  padding-right: 80px;
  padding: 2px;
}
#text-toolbar {
  border-radius: 8px;
}
#send-button {
  top: 30px;
}

/* copy pasta from code pen */

.wrapper {
  position: relative;
  display: inline-block;
}

.regular-input:focus {
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
}

.emoji-invoker {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
}
.emoji-invoker:hover {
  transform: scale(1.1);
}
.emoji-invoker > svg {
  fill: #b1c6d0;
}

.emoji-picker {
  position: absolute;
  z-index: 1;
  font-family: Montserrat;
  border: 1px solid #ccc;
  width: 16rem;
  height: 20rem;
  overflow: scroll;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 1px 1px 8px #c7dbe6;
}
.emoji-picker__search {
  display: flex;
}
.emoji-picker__search > input {
  flex: 1;
  border-radius: 10rem;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
}
.emoji-picker h5 {
  margin-bottom: 0;
  color: #b1b1b1;
  text-transform: uppercase;
  font-size: 0.8rem;
  cursor: default;
}
.emoji-picker .emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.emoji-picker .emojis:after {
  content: "";
  flex: auto;
}
.emoji-picker .emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
}
.emoji-picker .emojis span:hover {
  background: #ececec;
  cursor: pointer;
}
</style>
